var API_DOMAIN = "https://pskcrackersbilling.zentexus.in/api";

export default API_DOMAIN;
